

import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import { useContext } from "react";
import { AuthContext } from "./context/authContext/AuthContext";
import Envoie from "./pages/envoie/Envoie";
import DetailEnvoie from "./pages/envoie/DetailEnvoie";
import Infoperson from "./pages/infoperson/Infoperson";

function App() {
  const { user } = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          user ? <Home /> : <Navigate to={'/login'} />
        } />

        {/* Envois Part */}
        <Route path="/envois/detail/:id" element={
          user ? <DetailEnvoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois/:page" element={
          user ? <Envoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois" element={
          user ? <Envoie /> : <Navigate to={'/login'} />
        } />

        {/* Infos Person Part */} 
        <Route path="/infoperson" element={
          user ? <Infoperson /> : <Navigate to='/login' />
        } />

        {/* Auth Routes */}
        <Route path="/login" element={
          user ? <Navigate to={'/'} /> : <Login />
        } />
        <Route path="/register" element={
          user ? <Navigate to={'/'} /> : <Register />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
